import unwrapList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/unwrapList'
import type { LpuPromotion } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPromotions/types'

type PromotionsPage = {
  object_list?: LpuPromotion[] | Record<string, LpuPromotion>
  results?: LpuPromotion[] | Record<string, LpuPromotion>
}

/**
 * Список акций из SSR-контекста.
 *
 * Django может отдать массив или страницу пагинатора с `object_list`.
 */
export default function unwrapPromotions(value: unknown): LpuPromotion[] {
  if (!value) {
    return []
  }

  if (Array.isArray(value)) {
    return value
  }

  if (typeof value !== 'object') {
    return []
  }

  const page = value as PromotionsPage

  if (page.object_list) {
    return unwrapList(page.object_list)
  }

  if (page.results) {
    return unwrapList(page.results)
  }

  return unwrapList(value as LpuPromotion[] | Record<string, LpuPromotion>)
}
